const openSearch = (form) => {
  form.classList.add('--active')
}
const closeSearch = (form) => {
  form.classList.remove('--active')
}

const BtnSearch = () => {
  const btnSearch = document.querySelector('.btn-search')
  const form = btnSearch.closest('form')

  btnSearch.addEventListener('click', (e) => {
    if (form.classList.contains('--active') || window.innerWidth < 1024) return

    e.preventDefault()
    openSearch(form)
  })

  form.addEventListener('click', (e) => {
    e.stopPropagation()
  })

  document.addEventListener('click', () => {
    if (!form.classList.contains('--active')) return

    closeSearch(form)
  })
}
export default BtnSearch
